import { render, staticRenderFns } from "./PrivacyProtectConceptContent.vue?vue&type=template&id=74478cad&scoped=true&"
import script from "./PrivacyProtectConceptContent.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtectConceptContent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyProtectConceptContent.vue?vue&type=style&index=0&id=74478cad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74478cad",
  null
  
)

export default component.exports